/**
 * A timeout that can be held and let go again, keeping what it had left - for the AI answer's
 * auto-clear, which waits while the pointer is over the answer so it is not taken away mid-read.
 */

export type PausableTimeout = {
  pause(): void;
  resume(): void;
  cancel(): void;
};

export function pausableTimeout(fn: () => void, ms: number): PausableTimeout {
  let left = ms;
  let startedAt = Date.now();
  let timer: number | undefined = window.setTimeout(fn, left);
  let finished = false;

  return {
    pause() {
      if (finished || timer === undefined) return;
      window.clearTimeout(timer);
      timer = undefined;
      left = Math.max(0, left - (Date.now() - startedAt));
    },
    resume() {
      if (finished || timer !== undefined) return;
      startedAt = Date.now();
      timer = window.setTimeout(fn, left);
    },
    cancel() {
      finished = true;
      window.clearTimeout(timer);
      timer = undefined;
    },
  };
}
